import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import HebrewHeartsLogo from '../../assets/images/hebrew-hearts-logo.png';
import {
  hhFooterSx,
  hhFooterInnerSx,
  hhFooterBrandSx,
  hhFooterLogoRowSx,
  hhFooterLogoTextSx,
  hhFooterTaglineSx,
  hhFooterNavGridSx,
  hhFooterNavLabelSx,
  hhFooterLinksSx,
  hhFooterLinkSx,
  hhFooterBottomSx,
  hhFooterCopyrightSx,
} from '../../styles/hhPageStyles';

const exploreLinks = [
  { to: '/#join', label: 'Join Your City' },
  { to: '/how-it-works', label: 'How it Works' },
  { to: '/pricing', label: 'Pricing' },
];

const legalLinks = [
  { to: '/terms-of-service', label: 'Terms of Service' },
  { to: '/privacy-policy', label: 'Privacy Policy' },
  { to: '/contact', label: 'Contact' },
];

const Footer = () => {
  return (
    <Box component="footer" sx={hhFooterSx}>
      <Box sx={hhFooterInnerSx}>
        <Box sx={hhFooterBrandSx}>
          <Box
            component={Link}
            to="/"
            sx={{
              ...hhFooterLogoRowSx,
              textDecoration: 'none',
              width: 'fit-content',
              borderRadius: '12px',
              transition: 'opacity 0.15s ease',
              '&:hover': { opacity: 0.85 },
            }}
          >
            <Box
              component="img"
              src={HebrewHeartsLogo}
              alt=""
              sx={{ width: 36, height: 36, objectFit: 'contain' }}
            />
            <Typography component="span" sx={hhFooterLogoTextSx}>
              Hebrew Hearts
            </Typography>
          </Box>
          <Typography sx={hhFooterTaglineSx}>
            Meaningful connections for Jewish singles — launching one strong local community at a time.
          </Typography>
        </Box>

        <Box sx={hhFooterNavGridSx}>
          <Box>
            <Typography component="p" sx={hhFooterNavLabelSx}>
              Explore
            </Typography>
            <Box sx={hhFooterLinksSx}>
              {exploreLinks.map((link) => (
                <Box key={link.to} component={Link} to={link.to} sx={hhFooterLinkSx}>
                  {link.label}
                </Box>
              ))}
            </Box>
          </Box>

          <Box>
            <Typography component="p" sx={hhFooterNavLabelSx}>
              Legal
            </Typography>
            <Box sx={hhFooterLinksSx}>
              {legalLinks.map((link) => (
                <Box key={link.to} component={Link} to={link.to} sx={hhFooterLinkSx}>
                  {link.label}
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>

      <Box sx={hhFooterBottomSx}>
        <Typography component="p" sx={hhFooterCopyrightSx}>
          © {new Date().getFullYear()} Hebrew Hearts. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
